import React, { FC, Fragment, useContext, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import Slider from 'react-slick'
import { localeContext, LocaleProps } from '../../../index'
import AgendaItem from './AgendaItem'
import { LandingPageImages } from '../../../utils/links'

type AgendaProps = { 
    eventSlug: string
    data: any
 }

const Agenda: FC<AgendaProps> = ({eventSlug, data }) => {
    const { jsonData } = useContext(localeContext) as LocaleProps

    const intl = useIntl()

    const location = useLocation()

    // 該會場 agenda 數量  ([1, 2, 3 ...])
    const [topics, setTopics] = useState<string[]>([])
    // agenda 標示 ([1_1, 1_2 ...])
    const [symbols, setSymbols] = useState<string[]>([])
    // agenda 代碼 (T1S2...)
    const [venue, setVenue] = useState<string>(eventSlug as string)

    /**
     * 判斷是否帶上 event id
     * 蒐集 agenda 標示資訊及 agenda 代碼
     */
    useEffect(() => {
        if (eventSlug) {
            const symbols = handleGetSymbolAndTopics(eventSlug)

            setVenue(eventSlug)
            setSymbols(symbols)
        } else {
            const symbols = handleGetSymbolAndTopics(eventSlug as string)

            setVenue(eventSlug as string)
            setSymbols(symbols)
        }
    }, [location, venue, eventSlug])

    /**
     * @param ve 活動 event id
     * @returns symbols array
     * 整理 agenda 標示
     */
    const handleGetSymbolAndTopics = (ve: string): string[] => {
        const keys = Object.keys(jsonData)
        const topics = keys.filter((key) => {
            return key.includes(ve) && key.includes('#topic')
        })

        const spks = keys.filter((key) => {
            return key.includes(ve) && key.includes('#spk')
        })

        const symbols = topics.map((topic, i) => {
            return `${jsonData[topic]}_${jsonData[spks[i]]}`
        })

        const topicVals = topics.map((topic) => {
            return `${jsonData[topic]}`
        })

        setTopics([...new Set(topicVals)])

        return symbols
    }

    // slick config
    const settings = {
        dots: true,
        infinite: false,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: true,
                    infinite: false,
                    initialSlide: 0,
                },
            },
            {
                breakpoint: 1580,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    initialSlide: 0,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 1080,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    dots: true,
                    arrows: false,
                    swipe: true,
                    infinite: false,
                },
            },
        ],
    }

    return (
        <div className="landing-page-agenda-background" id="agenda" style={{ backgroundImage: `url(${data[0].attributes.landing_config.img_bg1})`}}>
            <div className="landing-page-agenda-wrap">
                {/* <div className="landing-page-agenda-detail">
                    <h1 className="page-title">{intl.formatMessage({ id: 'landingPage.nav_agenda' })}</h1>
                </div> */}
                <div className="landing-page-title">
                    {data[0].attributes.landing_config &&
                            <img className="landing-page-title-pc" src={data[0].attributes.landing_config.img_agenda} alt="" />
                    }
                     {data[0].attributes.landing_config &&
                            <img className="landing-page-title-mo" src={data[0].attributes.landing_config.img_agenda_mo} alt="" />
                        }


                
                </div>
                <div className="landing-page-agenda-slide-container">
                    <Slider {...settings} className="landing-page-agenda-slide">
                        {data[0].attributes.agendaList && data[0].attributes.agendaList.length > 0
                            ? data[0].attributes.agendaList.map((topic, index) => {
                                  return (
                                      <Fragment key={index}>
                                          <div className="landing-page-agenda-slide-item">
                                            {/* <div className="landing-page-agenda-slide-item-time">
                                                <span>
                                                    {topic.Time}
                                                </span>
                                            </div> */}
                                            <div className="landing-page-agenda-slide-item-topic">
                                                <span>
                                                    {topic.Topic}
                                                </span>
                                            </div>
                                            <div className="landing-page-agenda-slide-item-speaker">
                                                <div className="landing-page-agenda-slide-img-container">
                                                    <img
                                                        className="landing-page-agenda-slide-img"
                                                        src={topic.ImgUrl}
                                                        alt={topic.Topic}
                                                    />
                                                </div>
                                                <div className="landing-page-agenda-slide-content">
                                                    <div className="landing-page-agenda-slide-content-name" style={{ color: `${data && data[0]?.attributes?.landing_config?.priminary_color || ''}`}}>
                                                        {topic.SpeakerName}
                                                    </div>
                                                    <div className="landing-page-agenda-slide-content-title">
                                                        {topic.SpeakerTitle}
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                      </Fragment>
                                  )
                              })
                            : null}
                        {/* {topics && topics.length > 0
                            ? topics.map((topic) => {
                                  return (
                                      <Fragment key={`${topic}_1`}>
                                          <AgendaItem topic={topic} venue={venue} symbols={symbols} />
                                      </Fragment>
                                  )
                              })
                            : null} */}
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default Agenda
